import { credentialStorage } from "./credential-storage"
import { getSessionVersion } from "./session-version"

export function getAccessToken(): Promise<string | null> {
	return credentialStorage.get("access_token")
}

export function getRefreshToken(): Promise<string | null> {
	return credentialStorage.get("refresh_token")
}

export function setTokens(
	accessToken: string,
	refreshToken: string,
	version = getSessionVersion(),
): Promise<void> {
	return credentialStorage.set(
		{ access_token: accessToken, refresh_token: refreshToken },
		version,
	)
}

export function clearTokens(): Promise<void> {
	return credentialStorage.remove(["access_token", "refresh_token", "owner_id"])
}

export function getOwnerId(): Promise<string | null> {
	return credentialStorage.get("owner_id")
}

export function setOwnerId(ownerId: string): Promise<void> {
	return credentialStorage.set({ owner_id: ownerId })
}
